// import "sweetalert2/src/sweetalert2.scss";

import * as React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Swal from 'sweetalert2';

import onClickOutside from 'react-onclickoutside';
import NotifyHOC from '../../HOC/Notifications';

import * as Action from '../../actions/authentication.actions';
import * as TenantAction from '../../actions/tenantDropdown.actions';
import * as projectService from '../../services/project.service';

import { User } from '../../interface/user.interface';
import { uppercaseFirstLetter } from '@nexxt/common/services/TextService';
import { ITenantBrief } from '../../interface/tenant.interface';
import { getConfirmationBox } from '../common/swal/Sweetalert';
import {
    alertMessage,
    titleHeader,
    parseAlertMessage
} from '../../constants/alertMessage';
import {
    PanelType,
    Project,
    PROJECT_STATUS,
    VIEW_MODE
} from '@nexxt/common/types';
import { EDIT_NEW_PROJECT, PROJECTS } from '../../constants/routes';
import { dataTestid } from '../../constants/dataTestid';
import Loader from '../common/Loader/Loader';
import { interpolate } from '../../utils/string';
import { getAccessDevMode } from '@nexxt/common/firebase/auth/userDetails';
import TranslationImportModal from './TranslationImportModal';
import { UilEllipsisV } from '@iconscout/react-unicons';
interface IProjectDropdownProps {
    isEditor: boolean;
    project: Project;
    setTenant?: (tenant: ITenantBrief) => void;
    getAllTenants?: () => void;
    isTenantRequesting?: () => void;
    isTenantAccepted?: () => void;
    isRequesting?: boolean;
    toastNotification?: any;
    user?: User;
    allProjects?: any;
    getProjects?: (refresh?: boolean) => void;
    clearState?: () => void;
    changePath?: (path: string) => void;
    duplicateProjectToggle?: () => void;
    setDuplicateProject?: (project) => void;
    tenantId: number;
    disabled?: boolean;
    viewMode?: VIEW_MODE;
    isGlobal?: boolean;
}
interface IProjectDropdownState {
    isDropDownOpen: boolean;
    isConfirmationBoxOpen: boolean;
    isDuplicateProject: boolean;
    isLoading: boolean;
    showTranslationImportModal: boolean;
}
class ProjectDropdown extends React.Component<
    IProjectDropdownProps,
    IProjectDropdownState
> {
    constructor(props: Readonly<IProjectDropdownProps>) {
        super(props);
        this.state = {
            isDropDownOpen: false,
            isConfirmationBoxOpen: false,
            isDuplicateProject: false,
            isLoading: false,
            showTranslationImportModal: false
        };
    }
    handleClickOutside = () => {
        this.setState({
            isDropDownOpen: false
        });
    };
    handleDropdown = () => {
        this.setState({
            isDropDownOpen: !this.state.isDropDownOpen
        });
    };

    archiveSelectedProject = async (
        project: Project,
        user,
        isTenantAccepted
    ) => {
        try {
            await projectService.archiveProject(project.id);
            if (this.props.getProjects) {
                await this.props.getProjects(true);
            }
            this.props.toastNotification.success(
                parseAlertMessage(
                    alertMessage.SUCCESS_ARCHIVE_PROJECT,
                    uppercaseFirstLetter(project.name)
                )
            );
        } catch (err) {
            this.props.toastNotification.success(
                parseAlertMessage(
                    alertMessage.UNABLE_ARCHIVE_PROJECT,
                    uppercaseFirstLetter(project.title)
                )
            );
        }
    };

    setArchive = async (project: Project) => {
        const { isTenantRequesting, isTenantAccepted, user } = this.props;

        if (this.props.allProjects?.length <= 1) {
            getConfirmationBox({
                title: titleHeader.ARCHIVE_ACCOUNT,
                message: alertMessage.UNABLE_TO_ARCHIVE_DEFAULT_PROJECT,
                isMessageBold: true,
                showCloseButton: true,

                showCancelButton: false,
                iconClass: 'info'
            });
        } else {
            try {
                getConfirmationBox({
                    title: titleHeader.ARCHIVE_ACCOUNT,
                    message: alertMessage.ASK_BEFORE_ARCHIVE,
                    subMessage: alertMessage.ARCHIVE_ALERT,
                    showCloseButton: true,
                    confirmButtonColor: '#f68685',
                    iconClass: 'archive-acc'
                })
                    .then(async (result) => {
                        isTenantRequesting();
                        if (result.value) {
                            this.archiveSelectedProject(
                                project,
                                user,
                                isTenantAccepted()
                            );

                            this.props.clearState();
                        } else if (
                            result.dismiss === Swal.DismissReason.cancel
                        ) {
                            isTenantAccepted();
                        }
                    })
                    .finally(() => {
                        if (this.props.isEditor) {
                            this.props.changePath(PROJECTS);
                        }
                    });
            } catch (error) {
                isTenantAccepted();
                this.props.toastNotification.error(
                    parseAlertMessage(
                        alertMessage.UNABLE_ARCHIVE_PROJECT,
                        uppercaseFirstLetter(project.title)
                    )
                );
            }
        }
    };

    duplicateProject = (project) => {
        this.props.duplicateProjectToggle();
        this.props.setDuplicateProject(project);
    };

    downloadProjectDetails = async (type) => {
        try {
            getConfirmationBox({
                title: titleHeader.DOWNLOAD_PROJECT_INFO,
                message:
                    alertMessage.DOWNLOAD_PROJECT_INFO + ` Question/Option?`,
                subMessage: alertMessage.DOWNLOAD_PROJECT_INFO_SUB,
                showCloseButton: true,
                confirmButtonColor: '#349A71',
                iconClass: 'info'
            }).then(async (result) => {
                this.setState({ isLoading: true });
                if (result.value) {
                    const response = await projectService.downloadCSV(
                        this.props.project.id,
                        this.props.project.name,
                        this.props.tenantId,
                        type
                    );

                    if (response.response) {
                        this.props.toastNotification.error(
                            `(ERROR CODE: ${response.response})`
                        );
                    } else {
                        this.props.toastNotification.success(
                            parseAlertMessage(
                                alertMessage.SUCCESS_DOWNLOAD_CSV,
                                response.fileName
                            )
                        );
                    }
                }

                this.setState({ isLoading: false });
            });
        } catch (error) {
            this.props.toastNotification.error(
                parseAlertMessage(
                    alertMessage.DOWNLOAD_PROJECT_FAIL,
                    uppercaseFirstLetter(this.props.project.title)
                )
            );
        }
    };
    importProject = async (type: 'questions' | 'options') => {
        const { value: file } = await Swal.fire({
            title: 'Select import CSV',
            input: 'file',
            inputAttributes: {
                accept: '.csv',
                'aria-label': 'Upload your csv to import to this project'
            }
        });
        this.setState({ isLoading: true });
        const resp = await projectService.importCSV(
            this.props.project.id,
            type,
            file
        );
        if (resp === 'OK') {
            this.props.toastNotification.success('Successfully import the csv');
        } else {
            this.props.toastNotification.error(resp);
        }
        this.setState({ isLoading: false });
    };

    render() {
        const { isDropDownOpen } = this.state;
        const { project, disabled } = this.props;
        const isDevAllowedAccount = getAccessDevMode();
        const hasLaunched = project.status !== PROJECT_STATUS.DRAFT;
        const withIncaPanel =
            project.panelSettings?.panelType === PanelType.INCA;
        return (
            <div
                className={classnames('', {
                    'dropdown show': isDropDownOpen,
                    disabled
                })}
            >
                {this.state.showTranslationImportModal && (
                    <TranslationImportModal
                        isOpen={this.state.showTranslationImportModal}
                        languages={this.props.project.languages}
                        projectId={this.props.project.id}
                        onClose={() =>
                            this.setState({ showTranslationImportModal: false })
                        }
                    />
                )}
                {this.state.isLoading && <Loader isFixed />}
                <div
                    className={
                        this.props.isEditor
                            ? 'btn btn--md btn--green cursor-pointer ml-2'
                            : 'inca-card-button'
                    }
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded={'true'}
                    onClick={() => !disabled && this.handleDropdown()}
                >
                    More
                </div>
                <div
                    className={`dropdown-menu  dropdown-menu--right0 ${
                        isDropDownOpen ? 'show' : ''
                    } ${
                        this.props.isEditor
                            ? '!top-12 !right-7'
                            : '!top-6 !-right-7'
                    }`}
                    aria-labelledby="navbarDropdown"
                >
                    <div className={`dropdown-menu-container show`}>
                        <div className="inline-block m-r-2">
                            {hasLaunched ? (
                                <a
                                    className="dropdown-item"
                                    onClick={() =>
                                        this.props.changePath(
                                            `${interpolate(EDIT_NEW_PROJECT, {
                                                projectId: project.id
                                            })}`
                                        )
                                    }
                                >
                                    Edit Live Project
                                </a>
                            ) : null}
                            <a
                                className="dropdown-item"
                                onClick={() =>
                                    this.downloadProjectDetails('translation')
                                }
                            >
                                Question & Option Export
                            </a>
                            {/* {isDevAllowedAccount ? ( */}
                            <a
                                className="dropdown-item"
                                onClick={() =>
                                    this.setState({
                                        showTranslationImportModal: true
                                    })
                                }
                            >
                                Question & Option Import
                            </a>
                            {/* ) : null} */}
                            {!this.props.isGlobal &&
                                this.props.setDuplicateProject && (
                                    <a
                                        className="dropdown-item"
                                        href="#"
                                        onClick={() =>
                                            this.duplicateProject(project)
                                        }
                                    >
                                        Duplicate Project
                                    </a>
                                )}
                            {!this.props.isGlobal && (
                                <a
                                    className="dropdown-item"
                                    data-test={dataTestid.ARCHIVE_PROJECT}
                                    href="#"
                                    onClick={() => {
                                        this.setArchive(project);
                                    }}
                                >
                                    Archive Project
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    const {
        tenantReducer: { isRequesting },
        authReducer: { user },
        utilsReducer: { viewMode }
    } = store;
    return {
        isRequesting,
        user,
        viewMode
    };
};

const mapDispatchToProps = (dispatch) => ({
    setTenant: (tenant) => {
        dispatch(Action.setTenant(tenant));
    },
    isTenantRequesting: () => {
        dispatch(TenantAction.isTenantRequesting());
    },
    isTenantAccepted: () => {
        dispatch(TenantAction.isTenantAccepted());
    },
    changePath: (path) => {
        dispatch(push(path));
    }
});

export default NotifyHOC(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(onClickOutside(ProjectDropdown))
);
